<div *ngIf="isEnabled" class="category-header" [ngClass]="{ 'has-text-content': hasTextContent() }">
	<div class="category-bg" [ngStyle]="{ 'background-image': image ? 'url(' + image + ')' : 'none' }">
		<div class="category-content">
			<h1 *ngIf="header" data-cy="categoryName" class="category-name">{{ header | getText }}</h1>
			<div *ngIf="body" class="category-description" [innerHTML]="body | getText | withLineBreaks"></div>
		</div>
	</div>
</div>
